var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.allFilters),function(filter){return _c('filter-block-component',{key:filter.id,attrs:{"filter":filter}})}),_c('hr')],2)}
var staticRenderFns = []

export { render, staticRenderFns }